import React from "react";
import "./QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-fields';
import bc from "../../images/book-cover.svg";
import com from "../../images/compass-icon.svg";
import sh from "../../images/shield.svg";

function QuizHub() {
  return (
    <div className="quizhub-cont">
      <div className="ques-main quizhub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top">
                <div className="ques-top-title">
                  <h3>Quiz Hub</h3>
                  <p>
                    Explore all our Quizzez and discover deeper insights{" "}
                    <span> about your true self</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row quizhub-book-cards-row">
          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              <span className="quiz-top">MAIN QUIZ</span>

              <div className="quizhub-content">
                <h6>Personality Peek Test</h6>
                <p>
                  Personality Peek is a joyfully nerdy, psychology-inspired
                  playground made by a quirky
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              {/* <span className="quiz-top">MAIN QUIZ</span> */}

              <div className="quizhub-content">
                <h6>Your Dark Personality Unleashed</h6>
                <p>
                  Explore the hidden traits and shadow patterns that influence
                  your decisions and behavior.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              <span className="quiz-top">MAIN QUIZ</span>

              <div className="quizhub-content">
                <h6>Are You a Hero or a Villain in Your Story?</h6>
                <p>
                  Find out the role you naturally play in life and how it shapes
                  your relationships and choices.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              <span className="quiz-top">MAIN QUIZ</span>

              <div className="quizhub-content">
                <h6>What Is Your Supernatural Creature Match?</h6>
                <p>
                  Discover the mystical being that mirrors your energy,
                  instincts, and inner powers.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              {/* <span className="quiz-top">MAIN QUIZ</span> */}

              <div className="quizhub-content">
                <h6>
                  Are You Really Who You Think You Are? The Consistency Quiz
                </h6>
                <p>
                  See how aligned your self-perception is with your real
                  behavior and core pattern.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              <span className="quiz-top">MAIN QUIZ</span>

              <div className="quizhub-content">
                <h6>Which Cat Breed Are You?</h6>
                <p>
                  Find the cat that captures your personality, vibe, and unique
                  quirks perfectly.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="quiz-box">
              <div className="quiz-imgDiv">
                <img src={bc} alt="" />
              </div>
              <span className="quiz-top">MAIN QUIZ</span>

              <div className="quizhub-content">
                <h6>What's Your Archetype Life Path?</h6>
                <p>
                  Uncover the destiny your Archetype is here to take and the
                  legacy you're meant to create.
                </p>
                <div className="quizhub-btn">
                  <a href="" class="new-commom-btn quizhub-take">
                    <span>Take Now</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>

                  <a href="" class="new-commom-btn quiz-about">
                    <span>About Quiz</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row ">
          <div className="adapter-cta-div adapter-cta-div-in-ebook">
            <div className="adapt-cta-img">
              <div>
                <span>
                  <img src={com} alt="" />
                </span>
              </div>
            </div>
            <div className="adapt-cta-text">
              <h6>Your journey of self-discovery starts here.</h6>
              <p>
                Each quiz is designed to reveal a different layer of you.
                <span>Take one or explore them all.</span>
              </p>
            </div>
            <div className="adapt-cta-btn">
              <a href="" class="new-commom-btn adapter-btn">
                <span>Start Your First Quiz</span>
                <span class="righ-arr">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="quizhub-unique">
        <div className="container">
          <div className="row quizhub-unique-outer-row">
            <div className="col-md-3">
              <div className="quizhub-unibox">
                <span>
                  <img src={sh} alt="" />
                </span>
                <div>
                  <h6>Science-Backed </h6>
                  <p>
                    Built on the Archetypal <span>Spectral Model</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="quizhub-unibox">
                <span>
                  <img src={sh} alt="" />
                </span>
                <div>
                  <h6>Private & Secure</h6>
                  <p>
                    Your results are private <span>and never shared</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="quizhub-unibox">
                <span>
                  <img src={sh} alt="" />
                </span>
                <div>
                  <h6>Quick & Insightful </h6>
                  <p>
                    Takes just a few minutes,{" "}
                    <span>reveals a lifetime of insight</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="quizhub-unibox">
                <span>
                  <img src={sh} alt="" />
                </span>
                <div>
                  <h6>Grow & Evolve </h6>
                  <p>
                    Your insights to make <span>better choices and grow</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizHub;
